import { RefObject, useCallback } from 'react';

/** Focuses the input when the select is not in the active (locked) state. */
const useHandleFocusInputOnClick = ({
  lockActiveState,
  inputRef,
}: {
  lockActiveState: boolean;
  inputRef?: RefObject<HTMLInputElement | null>;
}) => {
  return useCallback(() => {
    if (!lockActiveState) {
      inputRef?.current?.focus();
    }
  }, [lockActiveState, inputRef]);
};

export default useHandleFocusInputOnClick;
